import { hex_sha256 } from './sha256';

const workspaceTokenKey = 'cloudstudio-gpu-token';
const urlUtils = (() => {
  const handlerBeforeunload = (e) => {
    e.preventDefault(); // FireFox
    e.returnValue = ''; // Chrome
  };
  return {
    isEmbeddedLoader() {
      try {
        if (window.location.pathname.startsWith('/ws/embeded') && window.parent !== window) {
          return true;
        }
      } catch (e) {
        return false;
      }
    },
    reloadWindow() {
      this.href(`/ws/${this.getSpaceKey()}?${(this.isEmbeddedLoader() ? window.parent : window).location.search}`);
    },
    href(url) {
      if (this.isEmbeddedLoader()) {
        window.parent.location.replace(url);
      } else {
        window.location.replace(url);
      }
    },
    getQueryParam (key)  {
      const search = this.isEmbeddedLoader() ? window.parent.location.search : window.location.search;
      const params = new URLSearchParams(search);
      return params.get(key);
    },
    getSpaceKey() {
      const pathname = this.isEmbeddedLoader() ? window.parent.location.pathname : window.location.pathname;
      const parts = pathname.split('/').filter(Boolean);
      if (parts.length === 1 || parts.length === 2) {
        return parts.pop();
      }
      return '';
    },
    getWsToken() {
      const search = decodeURIComponent(
        this.isEmbeddedLoader() ? window.parent.location.search : window.location.search,
      );
      const tokenItem =
        search
          .replace(/^\?/, '')
          .split('&')
          .find((item) => item.startsWith('token=')) || '';
      return tokenItem.split('=')[1];
    },
    // 开启退出拦截
    openBeforeunload() {
      window.addEventListener('beforeunload', handlerBeforeunload);
    },
    closeBeforeunload() {
      window.removeEventListener('beforeunload', handlerBeforeunload);
    },
    getCompanyName() {
      const host = window.location.host;
      return host.includes('127.0.0.1') ? 'codingcorp' : host.split('.cloudstudio')[0];
    },
    getLocationHost() {
      return window.location.host;
      // return "codingcorp.cloudstudio.net";
    },
    getLocationProtocol() {
      return window.location.protocol;
    },
    getDashboardUrl() {
      return `${window.location.origin}/dashboard`;
    },
    getTTYUrl() {
      return `${window.location.origin}/tty/${this.getSpaceKey()}/${window.location.search}`;
    },
    getQueryString(name, win = window) {
      const params = new URLSearchParams(win.location.search);
      return params.get(name);
    },
    sleep(time) {
      return new Promise((res) => setTimeout(() => res(), time));
    },
    // sha256
    hashSHA256(h) {
      return h ? hex_sha256(h) : '';
    },
    isIPV4(ip) {
      return /^(?:(?:25[0-5]|2[0-4]\d|(?:(?:1\d{2})|(?:[1-9]?\d)))\.){3}(?:25[0-5]|2[0-4]\d|(?:(?:1\d{2})|(?:[1-9]?\d)))$/.test(
        ip,
      );
    },
    isIPV6(ip) {
      return /^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$/.test(
        ip,
      );
    },
    isIPVAddress(ip) {
      return this.isIPV4(ip) || this.isIPV6(ip);
    },
    setCookie(name, value, iDay) {
      let oDate = new Date();
      oDate.setDate(oDate.getDate() + iDay);
      let sameSiteConf = '';
      if (location.protocol.toLocaleLowerCase() === 'https:') {
        sameSiteConf = 'SameSite=None; Secure;';
      }
      document.cookie = `${name}=${value};path=/;${sameSiteConf} expires=${oDate}`;
    },
    getCookie(name) {
      let arr,
        reg = new RegExp(`(^| )${name}=([^;]*)(;|$)`);
      // eslint-disable-next-line no-cond-assign
      if ((arr = document.cookie.match(reg))) return unescape(arr[2]);
      return null;
    },
    removeCookie(name) {
      this.setCookie(name, 1, -1);
    },
    outerHref() {
      let cur = window;
      let href = cur?.location?.href;
      try {
        // 一直查到到 top 或者遇到跨域
        while (cur !== window.top) {
          cur = cur.parent;
          href = cur.location.href;
        }
      } catch (err) {
        console.log(`outerHref err: ${err}`);
      }
      return href;
    },
    setWorkspaceToken(token) {
      sessionStorage.setItem(workspaceTokenKey, token);
    },
    getWorkspaceToken() {
      return sessionStorage.getItem(workspaceTokenKey);
    },
    rmWorkspaceToken() {
      sessionStorage.removeItem(workspaceTokenKey);
    },
  };
})();

export default urlUtils;
